export const emptyBandResult = {
  data: {
    'note': '각 페이지 별 multisection 정의 JSON 데이타',
    'type': 'pooq_multisection',
    'version': '1.0',
    'changekeyword': '',
    'gen_time': 'cf-search',
    'multisectionlist': [],
    'totalcount': '0'
  }
}

export const emptyListResult = {
  data: {
    'type': 'pooq_list',
    'sub_type': 'general_list',
    'gen_time': 'cf-search',
    'version': '1.0',
    'cell_toplist': {},
    'filter': {},
    'tvcut_bybroadcaster_list': {}
  }
}

export const emptySearchFaqList = {
  data: [
    {
      'type': 'searchinfo',
      'changekeyword': '',
      'totalcount': '0'
    }
  ]
}
